import React, { Component } from 'react'
import { connect } from 'react-redux'
import { removeMemberFromProject, changeMemberRoleProject, changeMemberTagsInProject } from '../../../../store/actions/projectActions';
import { get } from 'lodash';
import Loader from 'react-loader-spinner';

class ProjectManageMemberModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            newAccessLevel: -1,
            newAccessTitle: "",
            hasAllTags: false,
            selectedTagsIdList: [],
        }
    }

    /// README: TITLE AND DESCRIPTION STATE CHANGES
    handleChange = (e) => {
        switch (e.target.id) {
            case "hasAllTagsSelected": {
                const { hasAllTags } = this.state;
                const { toBeChangedEmployeeMapJson } = this.props;

                const newHasAllTags = !hasAllTags;
                const newSelectedTagsIdList = newHasAllTags ? [] : toBeChangedEmployeeMapJson['selectedTagsIdList'];

                this.setState({
                    hasAllTags: newHasAllTags,
                    selectedTagsIdList: newSelectedTagsIdList,
                })
                break;
            }
            default:
        }
    }

    /// README: SORTING TAGS BY NAME
    compare(a, b) {
        if ('name' in a && 'name' in b) {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
        }
        return 0;
    }

    /// README: HANDLE TAG SELECTION AND REMOVAL
    handleTagSelect = (tagMap) => {
        const { selectedTagsIdList } = this.state;
        var newSelectedTagIdList = selectedTagsIdList;
        if (selectedTagsIdList.indexOf(tagMap.tagid) === -1) {
            if (selectedTagsIdList.length < 5) {
                newSelectedTagIdList = [...newSelectedTagIdList, tagMap.tagid];
            } else {
                alert("More than 5 tags is not allowed!");
            }
        } else {
            newSelectedTagIdList = newSelectedTagIdList.filter(stagid => stagid !== tagMap.tagid);
        }

        this.setState({
            selectedTagsIdList: newSelectedTagIdList,
        })
    }

    /// README: CALLING CLOUD FUNCTION TO: 
    // PAPID 1: REMOVE A MEMBER FROM PROJECT
    removeMemberFromProject = () => {
        const { toBeChangedEmployeeMapJson, snagDetail } = this.props;
        if (toBeChangedEmployeeMapJson) {
            this.props.removeMemberFromProject(toBeChangedEmployeeMapJson, snagDetail);
        }
    }

    // PAPID 2: ROLE CHANGE IN PROJECT
    updateRoleChange = () => {
        const { changerEmployeeMapJson, toBeChangedEmployeeMapJson, snagDetail } = this.props;
        const { newAccessLevel } = this.state;
        if (changerEmployeeMapJson && toBeChangedEmployeeMapJson) {
            this.props.changeMemberRoleProject(changerEmployeeMapJson, toBeChangedEmployeeMapJson, snagDetail, newAccessLevel);
        }
    }

    // PAPID 4: CHANGE TAGS OF MEMBER
    changeMemberTagsInProject = () => {
        const { changerEmployeeMapJson, toBeChangedEmployeeMapJson, snagDetail } = this.props;
        const { hasAllTags, selectedTagsIdList } = this.state;
        if (changerEmployeeMapJson && toBeChangedEmployeeMapJson) {
            const selectedTagsIdListsWithElevation = hasAllTags ? selectedTagsIdList : [...selectedTagsIdList, 'elevation'];
            this.props.changeMemberTagsInProject(changerEmployeeMapJson, toBeChangedEmployeeMapJson, snagDetail, hasAllTags, selectedTagsIdListsWithElevation);
        }
    }

    handleRoleSelect = (prole) => {
        this.setState({
            newAccessLevel: prole.access,
            newAccessTitle: prole.title,
        })
    }

    componentDidMount() {
        const { toBeChangedEmployeeMapJson, alu } = this.props;
        if (toBeChangedEmployeeMapJson !== null) {
            const access = toBeChangedEmployeeMapJson.access;
            this.setState({
                newAccessLevel: access,
                newAccessTitle: alu.textLC[access],
                hasAllTags: toBeChangedEmployeeMapJson['hasAllTags'],
                selectedTagsIdList: toBeChangedEmployeeMapJson['selectedTagsIdList'],
            })
        } else {
            this.setState({
                newAccessLevel: 3,
                newAccessTitle: alu.textLC[3]
            })
        }
    }

    render() {
        const { modalWidth, modalTitleStyle, modalInfoTextStyle, alu, userData, toBeChangedEmployeeMapJson, snagDetail, themeColors, formLabelStyle, project, commons } = this.props;
        const { papiMessage, showPapiLoader } = project;
        const { newAccessTitle, hasAllTags, selectedTagsIdList } = this.state;
        const { projectRolesForInternals, projectRolesForExternals, isProjectInsider } = alu;
        const { coid, accessMap, tags } = snagDetail;

        const ueid = userData.uid + userData.employeeid;
        const tbcueid = toBeChangedEmployeeMapJson.uid + toBeChangedEmployeeMapJson.employeeid;
        const isChangerSame = ueid === tbcueid;

        const isInsider = isProjectInsider[toBeChangedEmployeeMapJson['access']];
        const relevantProjectRoles = isInsider ? projectRolesForInternals : projectRolesForExternals;

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm pr-4">
                    {/* ROLE CHANGE */}
                    <div>
                        {showPapiLoader ?
                            <div>
                                <Loader
                                    type="TailSpin"
                                    color={this.props.themeColors.themeColor}
                                    height={20}
                                    width={20}
                                />
                                <p style={{ color: "black", fontWeight: "bold", fontSize: "13px", marginTop: '5px', textAlign: 'center' }}>{showPapiLoader ? papiMessage ?? "" : <React.Fragment />}</p>
                            </div> : <React.Fragment />}
                        <p style={modalTitleStyle}>Change member role:</p>
                        <p style={modalInfoTextStyle}>* Assigning this role to {isChangerSame ? 'myself' : 'this member'} will provide or revoke their access to certain parts of this project.</p>
                        <br />
                        <div className="form-group text-left">
                            <div className="d-flex justify-content-between">
                                <div className="d-flex flex-row">
                                    <div className="align-self-center">
                                        <div className="dropdown show">
                                            <span className="btn btn-flat btn-sm dropdown-toggle border-bottom" role="button" id="roleDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ textTransform: 'capitalize' }}>
                                                {newAccessTitle}
                                            </span>
                                            <div className="dropdown-menu border" aria-labelledby="roleDropdownMenuLink">
                                                {relevantProjectRoles.map((prole, i) => {
                                                    return (
                                                        <span style={{ fontSize: "13px", textTransform: 'capitalize' }} onClick={() => { this.handleRoleSelect(prole) }} role="button" className="dropdown-item" key={i} data-toggle="tooltip" data-placement="top">
                                                            {prole.title}
                                                        </span>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-row">
                                    <div className="align-self-center">
                                        <div className="btn btn-dark btn-sm" style={{ borderRadius: '10px' }} onClick={() => this.updateRoleChange()}>Change the role</div>
                                    </div>
                                </div>
                            </div>
                            {/* <p style={{ color: "black", fontWeight: "bold", fontSize: "13px", marginTop: '5px', textAlign: 'center' }}>{showPapiLoader ? papiMessage ?? "" : <React.Fragment />}</p> */}
                        </div>
                    </div>
                    <hr />

                    {/* TAGS UPDATE */}
                    <div>
                        <p style={modalTitleStyle}>Assign or change {commons.tagCategories}:</p>
                        <p style={modalInfoTextStyle}>* Update or remove the tag {commons.tagCategories} assigned to {isChangerSame ? 'myself' : 'this member'}. {hasAllTags ? `Right now all ${commons.tagCategories} are selected.` : `You can only select a maximum of 5 ${commons.tagCategories}.`}</p>
                        <br />
                        <div className="form-group text-left">
                            {hasAllTags ?
                                (<React.Fragment />)
                                :
                                (
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex flex-row">
                                            <div className="align-self-center">
                                                <div className="row row-cols mx-3">
                                                    {'allTagsMap' in snagDetail ? Object.keys(snagDetail.allTagsMap).length > 1 ? Object.values(snagDetail.allTagsMap).sort(this.compare).filter(val => val.tagid !== "elevation").filter(val => (!val.name.includes('[DELETED]')) || (selectedTagsIdList.indexOf(val.tagid) !== -1 && val.name.includes('[DELETED]'))).map((val, i) => {
                                                        var pillBackgroundColor = selectedTagsIdList.indexOf(val.tagid) > -1 ? themeColors.themeColor : themeColors.themeColorTrans;
                                                        var pillTextColor = selectedTagsIdList.indexOf(val.tagid) > -1 ? "whitesmoke" : themeColors.themeColor;
                                                        return (
                                                            <div key={val.tagid} onClick={() => this.handleTagSelect(val)}>
                                                                <span className="badge badge-pill mx-1 px-3" role="button" style={{ backgroundColor: `${pillBackgroundColor}`, color: `${pillTextColor}`, textAlign: "end", fontSize: "12px" }}>{val.name ?? "undefined"}</span>
                                                            </div>
                                                        );
                                                    }) : `No ${commons.defectMarkers} found` : `No ${commons.defectMarkers} found`}
                                                </div>
                                            </div>
                                        </div>
                                    </div>)
                            }
                            <div className="form-group text-left mt-4">
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row">
                                        <div className="align-self-center">
                                            <div className="custom-control custom-checkbox mt-3">
                                                <input type="checkbox" className="custom-control-input ml-3" id="hasAllTagsSelected" name="hasAllTagsSelectedBox" checked={hasAllTags} onChange={this.handleChange} />
                                                <label className="custom-control-label" htmlFor="hasAllTagsSelected" style={formLabelStyle}>Select all {commons.tagCategories}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row">
                                        <div className="align-self-center">
                                            <div className="btn btn-dark btn-sm" style={{ borderRadius: '10px' }} onClick={() => this.changeMemberTagsInProject()}>Update {commons.tagCategories}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <p style={{ color: "black", fontWeight: "bold", fontSize: "13px", marginTop: '5px', textAlign: 'center' }}>{showPapiLoader ? papiMessage ?? "" : <React.Fragment />}</p> */}
                        </div>
                    </div>
                    <hr />

                    {/* REMOVE FROM PROJECT */}
                    <div>
                        <p style={modalTitleStyle}>Remove {isChangerSame ? 'myself' : 'member'} from project:</p>
                        <p style={modalInfoTextStyle}>* {isChangerSame ? "Leaving this project may or may not have any affects on your previous activity" : "Removing a member from your project may or may not have any affects on this member's previous activity"}.</p>
                        <br />
                        <div className="btn btn-danger btn-sm float-right" style={{ borderRadius: '12px' }} onClick={() => this.removeMemberFromProject()}>I willingly {isChangerSame ? 'leave' : 'remove member from'} this project</div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        floor: state.floor,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        companyData: state.firestore.data.Company,
        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        commons: state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        removeMemberFromProject: (toBeRemovedUserJson, projectModelJson) => dispatch(removeMemberFromProject(toBeRemovedUserJson, projectModelJson)),
        changeMemberRoleProject: (changerEmployeeMapJson, toBeChangedEmployeeMapJson, projectModelJson, newAccessLevel) => dispatch(changeMemberRoleProject(changerEmployeeMapJson, toBeChangedEmployeeMapJson, projectModelJson, newAccessLevel)),
        changeMemberTagsInProject: (changerEmployeeMapJson, toBeChangedEmployeeMapJson, projectModelJson, hasAllTags, selectedTagsIdList) => dispatch(changeMemberTagsInProject(changerEmployeeMapJson, toBeChangedEmployeeMapJson, projectModelJson, hasAllTags, selectedTagsIdList)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectManageMemberModal)
